import estilos from '../Documentacion.module.css'
import React, { Fragment, useState } from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import BotonSemaforoComponent from '../BotonesComponent/BotonSemaforoComponent';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Portal, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux'
import { ObtenerInformacionCliente, actualizarConstanciaFC11, generarConstanciaFC11 } from '../../../../../../../redux/DuckOrganismoCertificacion/SolicitudesFC01_OCDuck';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../../../../../redux/AppDucks';
import TextField from '@mui/material/TextField';
import { generarCertificadoExportacion } from '../../../../../../../redux/DuckOrganismoCertificacion/SolicitudesFC09_OCDuck';
import moment from 'moment';

const styleForm = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '70%', height: '90%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  'overflowY': 'scroll',
};

const styleModalConfirmacion = {
  position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
  width: 500, bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24,
  p: 4, fontSize: '20px', textAlign: 'center'
};

const CertificadoExportacionPromocionComponent = (props) => {
  const fechaHoy = moment().format('YYYY-MM-DD')
  let producto = props?.producto

  const dispatch = useDispatch()
  const informacionCliente = useSelector(store => store.SolicitudesFC01_OC.informacionCliente)
  const [checkboxValues, setCheckboxValues] = useState({
    apartado1: "v", apartado2: "v", apartado3: "v", apartado4: "v", apartado5: "v", apartado6: "v",
    apartado7: "v", apartado8: "v", apartado9: "v", apartado10: "v", apartado11: "v", apartado12: 'v'
  });

  const handleCheckboxChange = (label, value) => {
    setCheckboxValues((prevValues) => ({
      ...prevValues,
      [label]: value,
    }));
  };

  const [openModal, setOpenModal] = React.useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  }
  const modalFormulario = () => {
    return (
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleForm}>
          <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
            <div className='container'>
              <div className='container'>
                <div className='row'>
                  <div className={`text-center mb-4 ${estilos.titulo}`}><strong>CERTIFICADO DE EXPORTACIÓN PROMOCIÓN</strong></div>
                  <Formik
                    initialValues={{
                      idioma: '',
                      tipocertificado: '',
                      remplazaal: '',
                      sello: 'El producto ostenta sellos de certificación del COMERCAM',
                      producto: '',
                      categoria: '',
                      clase: '',
                      contraseña: '',
                      ingredientes: '',
                      estadoproductor: '',
                      fraccionarancelaria: '',
                      nombrecomun: '',
                      nombrecientifico: '',
                      razonsocialcomprador: '',
                      domiciliocomprador: '',
                      razonsocialexportador: '',
                      domicilioexportador: '',
                      razonsocialimportador: '',
                      domicilioimportador: '',
                      razonsocialorden: '',
                      domicilioorden: '',
                      destinatarionombre: '',
                      destinatariodomicilio: '',
                      pais: '',
                      aduanasalida: '',
                    }}
                    enableReinitialize={true}
                    validate={values => {
                      const errors = {};
                      if (!values.idioma) {
                        errors.idioma = 'Requerido!';
                      }
                      if (!values.tipocertificado) {
                        errors.tipocertificado = 'Requerido!';
                      }
                      return errors;
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                      handleOpenConfirmar(values)
                      setSubmitting(false);
                    }} >
                      {formikProps => (
                    <Form>
                      <div className={`container ${estilos.contenedorForm}`}>

                        <div className='row'>
                          <div className='col-1 col-xs-12 col-md-1 col-lg-1 col-xl-1'>
                            <label htmlFor="idioma">IDIOMA:</label><br />
                          </div>
                          <div className='col-4 col-xs-12 col-md-4 col-lg-4 col-xl-4'>
                            <Field as="select" id="idioma" name="idioma" style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}>
                              <option value="">Seleccione una opción</option>
                              <option value="Ingles">Ingles</option>
                              <option value="Español">Español</option>
                            </Field>
                            <ErrorMessage name="idioma" component="div" className={`${estilos.error}`} /><br />
                          </div>
                          <div className='col-1 col-xs-12 col-md-1 col-lg-1 col-xl-1'></div>
                          <div className='col-2 col-xs-12 col-md-2 col-lg-2 col-xl-2'>
                            <label htmlFor="tipocertificado">Tipo Certificado:</label><br />
                          </div>
                          <div className='col-4 col-xs-12 col-md-4 col-lg-4 col-xl-4'>
                            <Field as="select" id="tipocertificado" name="tipocertificado" style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}>
                              <option value="">Seleccione una opción</option>
                              <option value="Comprador">Comprador</option>
                              <option value="Destinatario Final">Destinatario Final</option>
                              <option value="Exportador e Importador">Exportador e Importador</option>
                              <option value="Importador">Importador</option>
                              <option value="Por Orden">Por Orden</option>
                            </Field>
                            <ErrorMessage name="tipocertificado" component="div" className={`${estilos.error}`} /><br />
                          </div>
                        </div><hr/>

                        <div className='row'>
                          <div className='col-4 col-xs-12 col-md-4 col-lg-4 col-xl-4'>
                            <label htmlFor="remplazaal">Reemplaza al:</label><br />
                          </div>
                          <div className='col-8 col-xs-12 col-md-8 col-lg-8 col-xl-8'>
                            <Field type="text" className="form-control" id="remplazaal" name="remplazaal" />
                            <ErrorMessage name="remplazaal" component="div" className={`${estilos.error}`} /><br />
                          </div>
                        </div><hr />
                        <div className={`text-center mb-4 `}><strong>DESCRIPCIÓN DEL PRODUCTO QUE AMPARA EL CERTIFICADO</strong></div>
                        <div className='row'>
                          <div className='col-2 col-xs-12 col-md-2 col-lg-2 col-xl-2'>
                            <label htmlFor="sello">Sello:</label><br />
                          </div>
                          <div className='col-10 col-xs-12 col-md-10 col-lg-10 col-xl-10'>
                            <Field type="text" className="form-control" id="sello" name="sello" />
                            <ErrorMessage name="sello" component="div" className={`${estilos.error}`} /><br />
                          </div>
                          <div className='col-4 col-xs-12 col-md-4 col-lg-4 col-xl-4'>
                            <label htmlFor="producto">Producto:</label><br />
                          </div>
                          <div className='col-8 col-xs-12 col-md-8 col-lg-8 col-xl-8'>
                            <Field type="text" className="form-control" id="producto" name="producto" />
                            <ErrorMessage name="producto" component="div" className={`${estilos.error}`} /><br />
                          </div>
                          <div className='col-4 col-xs-12 col-md-4 col-lg-4 col-xl-4'>
                            <label htmlFor="categoria">Categoria:</label><br />
                          </div>
                          <div className='col-8 col-xs-12 col-md-8 col-lg-8 col-xl-8'>
                            <Field type="text" className="form-control" id="categoria" name="categoria" />
                            <ErrorMessage name="categoria" component="div" className={`${estilos.error}`} /><br />
                          </div>
                          <div className='col-4 col-xs-12 col-md-4 col-lg-4 col-xl-4'>
                            <label htmlFor="clase">Clase:</label><br />
                          </div>
                          <div className='col-8 col-xs-12 col-md-8 col-lg-8 col-xl-8'>
                            <Field type="text" className="form-control" id="clase" name="clase" />
                            <ErrorMessage name="clase" component="div" className={`${estilos.error}`} /><br />
                          </div>
                          <div className='col-4 col-xs-12 col-md-4 col-lg-4 col-xl-4'>
                            <label htmlFor="contraseña">Contraseña NOM:</label><br />
                          </div>
                          <div className='col-8 col-xs-12 col-md-8 col-lg-8 col-xl-8'>
                            <Field type="text" className="form-control" id="contraseña" name="contraseña" />
                            <ErrorMessage name="contraseña" component="div" className={`${estilos.error}`} /><br />
                          </div>
                          <div className='col-4 col-xs-12 col-md-4 col-lg-4 col-xl-4'>
                            <label htmlFor="ingredientes">Ingrediente etiqueta:</label><br />
                          </div>
                          <div className='col-8 col-xs-12 col-md-8 col-lg-8 col-xl-8'>
                            <Field type="text" className="form-control" id="ingredientes" name="ingredientes" />
                            <ErrorMessage name="ingredientes" component="div" className={`${estilos.error}`} /><br />
                          </div>
                          <div className='col-4 col-xs-12 col-md-4 col-lg-4 col-xl-4'>
                            <label htmlFor="estadoproductor">Estado productor:</label><br />
                          </div>
                          <div className='col-8 col-xs-12 col-md-8 col-lg-8 col-xl-8'>
                            <Field type="text" className="form-control" id="estadoproductor" name="estadoproductor" />
                            <ErrorMessage name="estadoproductor" component="div" className={`${estilos.error}`} /><br />
                          </div>
                          <div className='col-4 col-xs-12 col-md-4 col-lg-4 col-xl-4'>
                            <label htmlFor="fraccionarancelaria">Fracción arancelaria:</label><br />
                          </div>
                          <div className='col-8 col-xs-12 col-md-8 col-lg-8 col-xl-8'>
                            <Field type="text" className="form-control" id="fraccionarancelaria" name="fraccionarancelaria" />
                            <ErrorMessage name="fraccionarancelaria" component="div" className={`${estilos.error}`} /><br />
                          </div>
                          <div className='col-4 col-xs-12 col-md-4 col-lg-4 col-xl-4'>
                            <label htmlFor="nombrecomun">Nombre común:</label><br />
                          </div>
                          <div className='col-8 col-xs-12 col-md-8 col-lg-8 col-xl-8'>
                            <Field type="text" className="form-control" id="nombrecomun" name="nombrecomun" />
                            <ErrorMessage name="nombrecomun" component="div" className={`${estilos.error}`} /><br />
                          </div>
                          <div className='col-4 col-xs-12 col-md-4 col-lg-4 col-xl-4'>
                            <label htmlFor="nombrecientifico">Nombre científico:</label><br />
                          </div>
                          <div className='col-8 col-xs-12 col-md-8 col-lg-8 col-xl-8'>
                            <Field type="text" className="form-control" id="nombrecientifico" name="nombrecientifico" />
                            <ErrorMessage name="nombrecientifico" component="div" className={`${estilos.error}`} /><br />
                          </div>
                        </div>
                        {formikProps.values.tipocertificado == 'Comprador' &&
                            <Fragment>
                              <div className={`text-center mb-4 `}><strong>COMPRADOR</strong></div>
                              <div className='row'>
                                <div className='col-4 col-xs-12 col-md-4 col-lg-4 col-xl-4'>
                                  <label htmlFor="razonsocialcomprador">Nombre o Razón Social:</label><br />
                                </div>
                                <div className='col-8 col-xs-12 col-md-8 col-lg-8 col-xl-8'>
                                  <Field type="text" className="form-control" id="razonsocialcomprador" name="razonsocialcomprador" />
                                  <ErrorMessage name="razonsocialcomprador" component="div" className={`${estilos.error}`} /><br />
                                </div>
                                <div className='col-4 col-xs-12 col-md-4 col-lg-4 col-xl-4'>
                                  <label htmlFor="domiciliocomprador">Domicilio:</label><br />
                                </div>
                                <div className='col-8 col-xs-12 col-md-8 col-lg-8 col-xl-8'>
                                  <Field type="text" className="form-control" id="domiciliocomprador" name="domiciliocomprador" />
                                  <ErrorMessage name="domiciliocomprador" component="div" className={`${estilos.error}`} /><br />
                                </div>
                              </div>
                            </Fragment>
                          }
                          {formikProps.values.tipocertificado == 'Exportador e Importador' &&
                            <Fragment>
                              <div className={`text-center mb-4 `}><strong>EXPORTADOR</strong></div>
                              <div className='row'>
                                <div className='col-4 col-xs-12 col-md-4 col-lg-4 col-xl-4'>
                                  <label htmlFor="razonsocialexportador">Nombre o Razón Social:</label><br />
                                </div>
                                <div className='col-8 col-xs-12 col-md-8 col-lg-8 col-xl-8'>
                                  <Field type="text" className="form-control" id="razonsocialexportador" name="razonsocialexportador" />
                                  <ErrorMessage name="razonsocialexportador" component="div" className={`${estilos.error}`} /><br />
                                </div>
                                <div className='col-4 col-xs-12 col-md-4 col-lg-4 col-xl-4'>
                                  <label htmlFor="domicilioexportador">Domicilio:</label><br />
                                </div>
                                <div className='col-8 col-xs-12 col-md-8 col-lg-8 col-xl-8'>
                                  <Field type="text" className="form-control" id="domicilioexportador" name="domicilioexportador" />
                                  <ErrorMessage name="domicilioexportador" component="div" className={`${estilos.error}`} /><br />
                                </div>
                              </div>
                              <div className={`text-center mb-4 `}><strong>IMPORTADOR</strong></div>
                              <div className='row'>
                                <div className='col-4 col-xs-12 col-md-4 col-lg-4 col-xl-4'>
                                  <label htmlFor="razonsocialimportador">Nombre o Razón Social:</label><br />
                                </div>
                                <div className='col-8 col-xs-12 col-md-8 col-lg-8 col-xl-8'>
                                  <Field type="text" className="form-control" id="razonsocialimportador" name="razonsocialimportador" />
                                  <ErrorMessage name="razonsocialimportador" component="div" className={`${estilos.error}`} /><br />
                                </div>
                                <div className='col-4 col-xs-12 col-md-4 col-lg-4 col-xl-4'>
                                  <label htmlFor="domicilioimportador">Domicilio:</label><br />
                                </div>
                                <div className='col-8 col-xs-12 col-md-8 col-lg-8 col-xl-8'>
                                  <Field type="text" className="form-control" id="domicilioimportador" name="domicilioimportador" />
                                  <ErrorMessage name="domicilioimportador" component="div" className={`${estilos.error}`} /><br />
                                </div>
                              </div>
                            </Fragment>
                          }
                          {formikProps.values.tipocertificado == 'Importador' &&
                            <Fragment>
                              <div className={`text-center mb-4 `}><strong>IMPORTADOR</strong></div>
                              <div className='row'>
                                <div className='col-4 col-xs-12 col-md-4 col-lg-4 col-xl-4'>
                                  <label htmlFor="razonsocialimportador">Nombre o Razón Social:</label><br />
                                </div>
                                <div className='col-8 col-xs-12 col-md-8 col-lg-8 col-xl-8'>
                                  <Field type="text" className="form-control" id="razonsocialimportador" name="razonsocialimportador" />
                                  <ErrorMessage name="razonsocialimportador" component="div" className={`${estilos.error}`} /><br />
                                </div>
                                <div className='col-4 col-xs-12 col-md-4 col-lg-4 col-xl-4'>
                                  <label htmlFor="domicilioimportador">Domicilio:</label><br />
                                </div>
                                <div className='col-8 col-xs-12 col-md-8 col-lg-8 col-xl-8'>
                                  <Field type="text" className="form-control" id="domicilioimportador" name="domicilioimportador" />
                                  <ErrorMessage name="domicilioimportador" component="div" className={`${estilos.error}`} /><br />
                                </div>
                              </div>
                            </Fragment>
                          }
                          {formikProps.values.tipocertificado == 'Por Orden' &&
                            <Fragment>
                              <div className={`text-center mb-4 `}><strong>POR ORDEN</strong></div>
                              <div className='row'>
                                <div className='col-4 col-xs-12 col-md-4 col-lg-4 col-xl-4'>
                                  <label htmlFor="razonsocialorden">Nombre o Razón Social:</label><br />
                                </div>
                                <div className='col-8 col-xs-12 col-md-8 col-lg-8 col-xl-8'>
                                  <Field type="text" className="form-control" id="razonsocialorden" name="razonsocialorden" />
                                  <ErrorMessage name="razonsocialorden" component="div" className={`${estilos.error}`} /><br />
                                </div>
                                <div className='col-4 col-xs-12 col-md-4 col-lg-4 col-xl-4'>
                                  <label htmlFor="domicilioorden">Domicilio:</label><br />
                                </div>
                                <div className='col-8 col-xs-12 col-md-8 col-lg-8 col-xl-8'>
                                  <Field type="text" className="form-control" id="domicilioorden" name="domicilioorden" />
                                  <ErrorMessage name="domicilioorden" component="div" className={`${estilos.error}`} /><br />
                                </div>
                              </div>
                            </Fragment>
                          }
                        <div className={`text-center mb-4 `}><strong>DESTINARIO FINAL</strong></div>
                        <div className='row'>
                        <div className='col-4 col-xs-12 col-md-4 col-lg-4 col-xl-4'>
                            <label htmlFor="destinatarionombre">Nombre o Razón Social:</label><br />
                          </div>
                          <div className='col-8 col-xs-12 col-md-8 col-lg-8 col-xl-8'>
                            <Field type="text" className="form-control" id="destinatarionombre" name="destinatarionombre" />
                            <ErrorMessage name="destinatarionombre" component="div" className={`${estilos.error}`} /><br />
                          </div>
                          <div className='col-4 col-xs-12 col-md-4 col-lg-4 col-xl-4'>
                            <label htmlFor="destinatariodomicilio">Domicilio:</label><br />
                          </div>
                          <div className='col-8 col-xs-12 col-md-8 col-lg-8 col-xl-8'>
                            <Field type="text" className="form-control" id="destinatariodomicilio" name="destinatariodomicilio" />
                            <ErrorMessage name="destinatariodomicilio" component="div" className={`${estilos.error}`} /><br />
                          </div>
                          <div className='col-4 col-xs-12 col-md-4 col-lg-4 col-xl-4'>
                            <label htmlFor="pais">País:</label><br />
                          </div>
                          <div className='col-8 col-xs-12 col-md-8 col-lg-8 col-xl-8'>
                            <Field type="text" className="form-control" id="pais" name="pais" />
                            <ErrorMessage name="pais" component="div" className={`${estilos.error}`} /><br />
                          </div>
                          <div className='col-4 col-xs-12 col-md-4 col-lg-4 col-xl-4'>
                            <label htmlFor="aduanasalida">Aduana de salida:</label><br />
                          </div>
                          <div className='col-8 col-xs-12 col-md-8 col-lg-8 col-xl-8'>
                            <Field type="text" className="form-control" id="aduanasalida" name="aduanasalida" />
                            <ErrorMessage name="aduanasalida" component="div" className={`${estilos.error}`} /><br />
                          </div>
                        </div>
                        <br /><br />
                        <div className='text-center'>
                          <button type="submit" className='btn btn-lg btn-success'> Generar Constancia </button>
                        </div>
                      </div>
                    </Form>
                      )}
                  </Formik>
                </div>
              </div>
            </div>
          </Typography>
          <br />
        </Box>
      </Modal>
    )
  }

  const [modalConfirmar, setModalConfirmar] = React.useState(false);
  const [valuesForm, setValuesForm] = React.useState(false);
  const handleOpenConfirmar = (values) => {
    setModalConfirmar(true);
    setValuesForm(values)
  }
  const handleCloseConfirmar = () => {
    setModalConfirmar(false);
  }
  const ModalConfirmar = () => {
    return (
      <Modal
        open={modalConfirmar}
        onClose={handleCloseConfirmar}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={styleModalConfirmacion} >
          <h3>Generar Certificado</h3>
          Estás seguro de querer generar este certificado? <br></br>
          <button onClick={() => generarCertificadoCumplimiento()} className='btn btn-danger'>Si, estoy seguro</button>
        </Box>

      </Modal>
    )
  }

  const generarCertificadoCumplimiento = async () => {
    /*await dispatch(actualizarLoadingApp_true())
    const fecharevision = new Date(valuesForm.fechaRevision)
    const fechaVigencia = new Date(valuesForm.fechaVigencia)
    const fechaVencimiento = new Date(valuesForm.fechaVencimiento)
    if (informacionCliente?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc11?.length == 0) {
      const dataCertificado = {
        numerosocio: informacionCliente?.fc_01_solicitudderegistro?.login?.cliente?.[0]?.numerosocio,
        instalaciones: informacionCliente?.fc_01_solicitudderegistro?.login?.cliente?.[0]?.anexocliente,
        checkboxValues: checkboxValues,
        fecharevision: fecharevision.toISOString(),
        numerosolicitud: valuesForm.noDeSolicitud,
        tipocertificado: valuesForm.tipoCertificado,
        producto: valuesForm?.producto,
        categoria: valuesForm?.categoria,
        clase: 'NO APLICA',
        marca: 'NO APLICA',
        tipoMaguey: 'NO APLICA',
        PorcentajeAlcohol: 'NO APLICA',
        numLoteGranel: 'NO APLICA',
        numLoteEnvasado: 'NO APLICA',
        contraseñaNOM: 'NO APLICA',
        hologramas: 'NO APLICA',
        numBotellas: 'NO APLICA',
        presentacion: 'NO APLICA',

        numDictamen: '',
        numAnalisis: 'NO APLICA',
        emitidoPorUno: 'NO APLICA',
        emitidoPorDos: 'NO APLICA',
        emitidoPorTres: 'NO APLICA',

        apartado1: checkboxValues?.apartado1,
        apartado2: checkboxValues?.apartado2,
        apartado3: checkboxValues?.apartado3,
        apartado4: checkboxValues?.apartado4,
        apartado5: checkboxValues?.apartado5,
        apartado6: checkboxValues?.apartado6,
        apartado7: checkboxValues?.apartado7,
        apartado8: checkboxValues?.apartado8,
        apartado9: checkboxValues?.apartado9,
        apartado10: checkboxValues?.apartado10,
        apartado11: checkboxValues?.apartado11,

        noCertificado: valuesForm?.noCertificado,
        criterio: valuesForm?.criterio,
        Cumple: checkboxValues?.apartado12,
        fechaVigencia: fechaVigencia?.toISOString(),
        fechaVencimiento: fechaVencimiento?.toISOString(),

        observaciones: '---',

        idsolicitudesocfc01: informacionCliente?.ocsolicitudfc01?.[0]?.idsolicitudesocfc01,

      }
      await dispatch(generarConstanciaFC11(dataCertificado))
    } else {
      const dataCertificado = {
        numerosocio: informacionCliente?.fc_01_solicitudderegistro?.login?.cliente?.[0]?.numerosocio,
        instalaciones: informacionCliente?.fc_01_solicitudderegistro?.login?.cliente?.[0]?.anexocliente,
        checkboxValues: checkboxValues,
        fecharevision: fecharevision.toISOString(),
        numerosolicitud: valuesForm.noDeSolicitud,
        tipocertificado: valuesForm.tipoCertificado,
        producto: valuesForm?.producto,
        categoria: valuesForm?.categoria,
        clase: 'NO APLICA',
        marca: 'NO APLICA',
        tipoMaguey: 'NO APLICA',
        PorcentajeAlcohol: 'NO APLICA',
        numLoteGranel: 'NO APLICA',
        numLoteEnvasado: 'NO APLICA',
        contraseñaNOM: 'NO APLICA',
        hologramas: 'NO APLICA',
        numBotellas: 'NO APLICA',
        presentacion: 'NO APLICA',

        numDictamen: '',
        numAnalisis: 'NO APLICA',
        emitidoPorUno: 'NO APLICA',
        emitidoPorDos: 'NO APLICA',
        emitidoPorTres: 'NO APLICA',

        apartado1: checkboxValues?.apartado1,
        apartado2: checkboxValues?.apartado2,
        apartado3: checkboxValues?.apartado3,
        apartado4: checkboxValues?.apartado4,
        apartado5: checkboxValues?.apartado5,
        apartado6: checkboxValues?.apartado6,
        apartado7: checkboxValues?.apartado7,
        apartado8: checkboxValues?.apartado8,
        apartado9: checkboxValues?.apartado9,
        apartado10: checkboxValues?.apartado10,
        apartado11: checkboxValues?.apartado11,

        noCertificado: valuesForm?.noCertificado,
        criterio: valuesForm?.criterio,
        Cumple: checkboxValues?.apartado12,
        fechaVigencia: fechaVigencia?.toISOString(),
        fechaVencimiento: fechaVencimiento?.toISOString(),

        observaciones: '--',

        idsolicitudesocfc01: informacionCliente?.ocsolicitudfc01?.[0]?.idsolicitudesocfc01,
        idsolicitudesocfc11: informacionCliente?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc11?.[0]?.idsolicitudesocfc11,

      }
      await dispatch(actualizarConstanciaFC11(dataCertificado))
    }
    setModalConfirmar(false);
    setOpenModal(false)
    await dispatch(ObtenerInformacionCliente(informacionCliente?.idsolicitudesuifc01))
    await dispatch(actualizarLoadingApp_false())*/
    const fechaVencimiento = moment(fechaHoy).add(3, 'months');
    
    let dataCertificado = {
      idioma: valuesForm.idioma,
      tipocertificado: valuesForm.tipocertificado,
      remplazaal: valuesForm.remplazaal,
      sello: valuesForm.sello,
      producto: valuesForm.producto,
      categoria: valuesForm.categoria,
      clase: valuesForm.clase,
      passwordnom: valuesForm.contraseña,
      ingredientes: valuesForm.ingredientes,
      estadoproductor: valuesForm.estadoproductor,
      fraccionarancelaria: valuesForm.fraccionarancelaria,
      nombrecomun: valuesForm.nombrecomun,
      nombrecientifico: valuesForm.nombrecientifico,
      razonsocialdestinatario: valuesForm.destinatarionombre,
      domiciliodestinatario: valuesForm.destinatariodomicilio,
      pais: valuesForm.pais,
      aduanasalida: valuesForm.aduanasalida,

      numerocertificado: '',
      fechaemision: new Date(fechaHoy).toISOString(),
      fechavencimiento: new Date(fechaVencimiento).toISOString(),
      marca: producto?.marca,
      contenidoalcoholico: producto?.contenidoalcoholico,
      loteenvasado: producto?.numerolote,
      numerodictamen: '',
      analisislaboratorio: producto?.numeroanalisis,
      numerobotellas: producto?.numerobotellas,
      numerocajas: producto?.numerocajas,
      presentacion: producto?.contenidonetobotella + ' ' + producto?.unidad,
      razonsocialsolicitante: '',
      domiciliosolicitante: '',
      rfcsolicitante: '',
      razonsocialcomprador: valuesForm.razonsocialcomprador,
      domiciliocomprador: valuesForm.domiciliocomprador,
      razonsocialexportador: valuesForm.razonsocialexportador,
      domicilioexportador: valuesForm.domicilioexportador,
      razonsocialimportador: valuesForm.razonsocialimportador,
      domicilioimportador: valuesForm.domicilioimportador,
      razonsocialorden: valuesForm.razonsocialorden,
      domicilioorden: valuesForm.domicilioorden,
      certificado:'Promocion'
    }
    await dispatch(generarCertificadoExportacion(dataCertificado))
  }
  return (
    <Fragment><br />
      <Tooltip title="Nuevo archivo">
        <IconButton size="large" onClick={() => setOpenModal(true)} >
          <NoteAddIcon fontSize="inherit"
            style={informacionCliente?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc11?.length > 0 ? { fill: 'green' } : { fill: '#2B2B2B' }} />
        </IconButton>
      </Tooltip>
      {modalFormulario()}
      {ModalConfirmar()}
    </Fragment>
  )
}

export default CertificadoExportacionPromocionComponent